import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { distributorLogin } from "../services/api";
import { useAppConfig } from "../context/AppConfigContext";
import { useTranslation } from "../i18n/LanguageContext";
import LanguageSwitcher from "../components/LanguageSwitcher";

export default function DistributorLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { appName, branding, loginHeader, loginLogo } = useAppConfig();
  const { t, i18nEnabled } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await distributorLogin({ email, password });
      localStorage.setItem("distributor_token", res.data.token);
      localStorage.setItem("distributor", JSON.stringify(res.data.distributor));
      navigate("/distributor");
    } catch (err) {
      setError(err.response?.data?.error || t("login.failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        {i18nEnabled && (
          <div className="flex justify-end mb-2">
            <LanguageSwitcher />
          </div>
        )}
        {loginHeader === "logo" ? (
          <div className="flex justify-center mb-2">
            <img
              src={loginLogo || branding.logo}
              alt={appName}
              className="h-36 object-contain"
              onError={(e) => { e.target.style.display = "none"; }}
            />
          </div>
        ) : (
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-2">
            {appName}
          </h1>
        )}
        <p className="text-center text-gray-500 mb-8">
          {t("distributor.login_title")}
        </p>

        {error && (
          <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("login.email")}
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("login.password")}
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? t("login.submitting") : t("login.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
